import _ from 'lodash';

export const SAGA_GET_POIS = 'SAGA_GET_POIS';
export const SAGA_SET_POI_VIEWPORT = 'SAGA_SET_POI_VIEWPORT';
export const SAGA_GET_BOUNDARIES = 'SAGA_GET_BOUNDARIES';
export const SET_POI_VIEWPORT = 'SET_POI_VIEWPORT';
export const SET_POI_ORGANIZATION_FILTERS = 'SET_POI_ORGANIZATION_FILTERS';
export const SET_POIS = 'SET_POIS';
export const CONCAT_POIS = 'CONCAT_POIS';
export const RESET_POIS = 'RESET_POIS';

export const CONCAT_BOUNDARIES = 'CONCAT_BOUNDARIES';
export const RESET_BOUNDARIES = 'RESET_BOUNDARIES';
export const SET_BOUNDARIES = 'SET_BOUNDARIES';

export const setPOIOrganizationFilters = (organizationIds) => ({
    type: SET_POI_ORGANIZATION_FILTERS,
    payload: {
        organizationIds,
    }
});

export const setPOIViewport = (topLeft, bottomRight) => ({
    type: SET_POI_VIEWPORT,
    payload: {
        topLeft,
        bottomRight,
    },
});

export const sagaGetPOIs = (topLeft, bottomRight, organizationIds, country, pageNumber) => ({
    type: SAGA_GET_POIS,
    payload: {
        topLeft,
        bottomRight,
        pageNumber: pageNumber ? pageNumber : 0,
        country,
        organizationIds: _.isArray(organizationIds) ? organizationIds : null,
    }
});

export const sagaGetBoundaries = (topLeft, bottomRight, boundaryType, country, page = 0) => ({
    type: SAGA_GET_BOUNDARIES,
    payload: {
        topLeft,
        bottomRight,
        boundaryType,
        country,
        page,
    }
});

export const sagaCancelGetPOIs = () => ({
    type: SAGA_GET_POIS,
    payload: {
        cancelRequest: true,
    }
});

export const sagaCancelGetBoundaries = () => ({
    type: SAGA_GET_BOUNDARIES,
    payload: {
        cancelRequest: true,
    }
});


// WEBPACK FOOTER //
// ./src/POI/actions.js